import * as React from "react";

// plugin imports
import axios from "axios";

// utils imports

// svg imports

export const RouteContext = React.createContext({
	location: undefined,
});

const defaultValues = {
	fetchCarta: () => {},
	menusData: undefined,
	menuError: false,
};

export const MenuDataContext = React.createContext(defaultValues);

export const MenuDataProvider = ({ children }) => {
	const [menusData, setMenusData] = React.useState(undefined);
	const [menusError, setMenusError] = React.useState(false);

	const fetchCarta = async () => {
		if (!menusData) {
			axios
				.get(`https://cdn.italiamos.com/data/Full.json`)
				.then((response) => {
					const cartaArray = [];

					const platos = response.data.values;

					for (var i = 1; i < platos.length; i++) {
						// we start at i = 1 cause i = 0 are headers

						var row = {}; // Create a new row object for each row
						for (var j = 0; j < 100; j++) {
							if (platos[i][j] === undefined) {
								break;
							}
							row[platos[0][j]] = platos[i][j];
						}
						cartaArray.push(row); // Push the row object to the output array
					}

					setMenusData(cartaArray);
				})
				.catch((error) => {
					console.error("Error:", error);
					setMenusError(error);
				});
		}
	};

	const [showModoMioPopUp, setShowModoMioPopUp] = React.useState(false);

	return (
		<MenuDataContext.Provider
			value={{
				...defaultValues,
				fetchCarta,
				menusData,
				menusError,
				showModoMioPopUp,
				setShowModoMioPopUp,
			}}
		>
			{children}
		</MenuDataContext.Provider>
	);
};
